import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                  国
                </span>
                <span className="font-heading font-bold text-lg text-background-50">
                  国产在线观看
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                {siteInfo.description.slice(0, 80)}...
              </p>
              <div className="flex items-center gap-3">
                <a
                  href={siteInfo.socialLinks.weibo}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                视频分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    帮助中心
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    用户协议
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-mail-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-phone-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line mt-0.5 text-background-500"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 高清国产视频免费在线观看平台
            </p>
            <p className="text-xs text-background-500">
              国产在线观看,国产视频在线观看,高清国产视频,免费在线观看国产
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}